import { Collapse, Table } from "antd";
import React, { useState } from "react";
import { buildQueryString, showError, formatNumber } from "../../../../utils/utilities";
import { paginationDefaults } from "../../../../utils/properties";
import { useSelector, useDispatch } from "react-redux";
import { setFilters } from "../../../../redux/ducks/Filters";
import { cloneDeep, get, isEmpty, toUpper } from "lodash";
import { useTranslation } from "react-i18next";
import PfpService from "../../../../services/api/PfpService";
import { setLoading } from "../../../../redux/ducks/Loading";

const Team = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const filters = useSelector((state) => state.FiltersDuck.filters);
  const [state, setState] = useState({
    teamKeys: ["internal", "external"],
    tableContent: {
      internal: [],
      external: [],
    },
    pagination: {
      currentPage: paginationDefaults.page,
      size: paginationDefaults.size,
      totalItems: paginationDefaults.totalItems,
    },
    activePanel: undefined,
  });

  const dataList = async (queryString, key) => {
    dispatch(setLoading(true));
    const servicesList = await PfpService.getServicesList(queryString);
    if (!servicesList.error && servicesList.data) {
      servicesList.data.forEach((si, i) => {
        si.key = i; // This is necessary to remove warning in console for unique key row
      });
      let tableContentData = cloneDeep(state.tableContent);
      state.teamKeys.forEach((t) => {
        if (t === key) {
          tableContentData[t] = servicesList.data;
        }
      });
      setState((prevState) => ({
        ...prevState,
        activePanel: key,
        tableContent: tableContentData,
      }));
    } else {
      showError(get(servicesList, "error.messageCode", "ER000"));
    }
    dispatch(setLoading(false));
  };

  const onChangeCollapse = async (key) => {
    if (!key) return;
    key = key[0];
    if (isEmpty(state.tableContent[key]) && key) {
      const queryString = buildQueryString(filters.obj, { type: toUpper(key), unitPrice: "HOUR", allPages: true });
      dataList(queryString.string, key);
    } else {
      setState((prevState) => ({ ...prevState, activePanel: key })); // I define activeKey only here if is undefined becouse if is not undefined, activeKey is set on dataList
    }
  };

  const columns = [
    {
      title: t("projectEstimate.detail.tabs.team.titleServiceResource"),
      dataIndex: "name",
      key: "id",
    },
    {
      title: t("projectEstimate.detail.tabs.team.titleBudget"),
      dataIndex: "basePrice",
      key: "id",
      className: "table-value-right-alsoheader",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR" }),
    },
  ];

  const items = state.teamKeys.map((team) => ({
    key: team,
    label: t(`projectEstimate.detail.tabs.team.${team}`),
    className: "mb-1em",
    children: (
      <Table
        rowKey="id"
        dataSource={state.tableContent[team]}
        columns={columns}
        size="small"
        pagination={{
          current: state.pagination.currentPage,
          pageSize: state.pagination.size,
          total: state.pagination.totalItems,
          onChange: (page, pageSize) => {
            const queryString = buildQueryString(filters.obj, { page: page - 1, size: pageSize });
            dispatch(setFilters(queryString));
            setState((prevState) => ({
              ...prevState,
              pagination: {
                currentPage: page,
                size: pageSize,
                totalItems: state.pagination.totalItems,
              },
            }));
            dataList(queryString.string);
          },
        }}
      />
    ),
  }));

  return (
    <>
      <Collapse items={items} activeKey={state.activePanel} onChange={onChangeCollapse} accordion />
    </>
  );
};

export default Team;
